export default {
  companiesThatWeRecommend: "These are companies that we recommend to our ventures.",
  company: "Company",
  directory: "Directory",
};
